import React from "react";
import { createUseStyles } from "react-jss";
import { useFontSizeV2 } from "../hooks/useDimension";

const useStyles = createUseStyles({
  cardContainer: {
    Container: {
      WebkitTouchCallout: "none",
      WebkitUserSelect: "none",
      KhtmlUserSelect: "none",
      MozUserSelect: "none",
      MsUserSelect: "none",
      userSelect: "none",
    },
    // border: '1px solid',
    padding: ({ isMobile }) => (isMobile ? "8px 0px 24px 0px" : 0),
    borderRadius: ({ fontSize }) => fontSize.xs,
    background: ({ isNonBackground }) => (isNonBackground ? "" : "white"),
    height: "100%",
    boxShadow: ({ isNonBackground }) =>
      isNonBackground
        ? ""
        : "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
    boxSizing: "border-box",
    border: ({ isBorder }) => (isBorder ? "1px solid #8982823B" : ""),
  },
});

export default function MainCard({
  children,
  isMobile,
  className,
  isNonBackground,
  isBorder,
  style = {},
}) {
  const fontSize = useFontSizeV2();
  const classes = useStyles({ fontSize, isMobile, isNonBackground, isBorder });
  return (
    <div
      className={`main-card ${classes.cardContainer} ${className}`}
      style={style}
    >
      {children}
    </div>
  );
}
